<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    피재자-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 피재자</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">성명</div>
        <p  v-if="isPrint" class=" print-input flex-1">{{ name }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="name"
          @focus="onNameFocus"
          @blur="onNameBlur"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">소속</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">직종</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_3"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">주민등록번호</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_4"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">입사일</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputB_5 }}
        </p>
        <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.inputB_5" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">임금</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_6"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">주소</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_7 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_7"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">사고장소</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_8 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputB_8"
          class="w-full flex-1"
        />
      </div>
    </div>

<!--    보고내용-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 보고내용</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">목격자 성명</div>
        <p  v-if="isPrint" class=" print-input flex-1">{{ observerName }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="observerName"
          @focus="onNameFocusObserver"
          @blur="onNameBlurObserver"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">주민등록번호</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_2 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">직종</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_3 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_3"
          class="w-full flex-1"
        />
      </div>

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">안전관리자</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_4 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_4"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공사과장</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_5 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_5"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">근로자대표</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_6 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_6"
          class="w-full flex-1"
        />
      </div>

      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">내용</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_7 }}</p>
        <ml-textarea
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_7"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">상병부위 및 상병명</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_8 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_8"
          class="w-full flex-1"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">치료예상기간</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_9 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_9"
          class="w-full flex-1"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">현지 의료기관명</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_10 }}</p>
        <ml-input
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_10"
          class="w-full flex-1"
        />
      </div>

      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">사후조치</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_11 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_11"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">현장의견</div>
        <p v-if="isPrint" class=" print-textarea flex-1">{{ form.inputC_12 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_12"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사고상황도"
      :grid-title="gridTitleList"
      :not-input="true"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (this.form.inputB_1 !== null && this.form.inputB_1 !== '') {
          this.name = this.form.inputB_1
          this.onNameBlur()
        }
        if (this.form.inputC_1 !== null && this.form.inputC_1 !== '') {
          this.observerName = this.form.inputC_1
          this.onNameBlurObserver()
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onNameFocus () {
      this.name = this.form.inputB_1
    },
    onNameBlur () {
      this.form.inputB_1 = this.name
      const length = this.name.length
      if (2 < length) {
        const first = this.name[0]
        const last = this.name[this.name.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        this.name = first + star + last
      } else if (length === 2) {
        const first = this.name[0]
        this.name = `${first  }*`
      }
    },
    onNameFocusObserver () {
      this.observerName = this.form.inputC_1
    },
    onNameBlurObserver () {
      this.form.inputC_1 = this.observerName
      const length = this.observerName.length
      if (2 < length) {
        const first = this.observerName[0]
        const last = this.observerName[this.observerName.length - 1]
        let star = ''
        for (let index = 0; index < length - 2; index++) {
          star += '*'
        }
        this.observerName = first + star + last
      } else if (length === 2) {
        const first = this.observerName[0]
        this.observerName = `${first  }*`
      }
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",
        inputC_12: "",

        photoList: [],
        fileList: [],
      },
      name: '',
      observerName: '',
      gridTitleList: [
        '1. 현장 Lay Out(사고위치 표시)',
        '2. 사고발생 상세도(작업방법 및 주변상황 표기)'
      ]
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
